import { jsx as _jsx } from "react/jsx-runtime";
import { Primary } from "@cinch-labs/design-system";
import styles from "./zendesk-messenger.module.css";
import { CommentsSharpIcon } from "./comments-sharp-regular";
var onClick = function() {
    if ("object" !== "undefined" && window.zE) {
        window.zE("messenger", "open");
    }
};
export var ZendeskChatButton = function() {
    var ref;
    var IS_MOBILE_APP = "object" !== "undefined" && ((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent.includes("cinchapp"));
    return !IS_MOBILE_APP ? /*#__PURE__*/ _jsx("div", {
        className: styles["buttonContainer"],
        "data-testid": "zendesk-chat-button-container",
        children: /*#__PURE__*/ _jsx(Primary, {
            id: "zendesk-chat-button",
            "aria-label": "Chat with us",
            onClick: function() {
                return onClick();
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: styles["commentIcon"],
                children: /*#__PURE__*/ _jsx(CommentsSharpIcon, {})
            })
        })
    }) : null;
};
